import { indexBy, prop } from 'ramda'

export const AppUserStatusEnums = {
  INACTIVE: -1,
  PAUSE: 0, // 暫停
  ACTIVE: 1,
}

// banner 上架狀態 0:未執行, 1:執行中, 2:已執行
export const AppBannerShelfStatus = [
  { value: 0, label: '未執行' },
  { value: 1, label: '執行中' },
  { value: 2, label: '已執行' },
]

export enum ReserveResult {
  inProgress = '0',
  completed = '1',
  cancel = '2',
  expired = '3',
}

export const ReserveResultLabels = {
  [ReserveResult.inProgress]: '預約中',
  [ReserveResult.completed]: '已完成',
  [ReserveResult.cancel]: '自行取消',
  [ReserveResult.expired]: '過期取消',
}

export const useMissionStatusEnum = () => {
  const statusEnum = {
    PENDING: 0,
    PROCESSING: 1,
    FINISHED: 2,
  }

  const data = [
    {
      id: 0,
      label: '待執行',
    },
    {
      id: 1,
      label: '執行中',
    },
    {
      id: 2,
      label: '已結束',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}

export const useRewardTypeEnum = () => {
  const statusEnum = {
    TIME: 0,
    PLACE: 1,
  }

  const data = [
    {
      id: 0,
      label: '指定時間',
    },
    {
      id: 1,
      label: '指定地點',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}

export const useMissionTypeEnum = () => {
  const statusEnum = {
    WEEKLY: 0,
    MONTHLY: 1,
    ONCE: 3,
  }

  const data = [
    {
      id: 0,
      label: '每周',
    },
    {
      id: 1,
      label: '每月',
    },
    {
      id: 3,
      label: '一次性',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}
export const useWeeklyOptionsEnum = () => {
  const statusEnum = {
    MONDAY: '1',
    TUESDAY: '2',
    WEDNESDAY: '3',
    THURSDAY: '4',
    FRIDAY: '5',
    SATURDAY: '6',
    SUNDAY: '7',
  }

  const data = [
    { id: '1', label: '週一' },
    { id: '2', label: '週二' },
    { id: '3', label: '週三' },
    { id: '4', label: '週四' },
    { id: '5', label: '週五' },
    { id: '6', label: '週六' },
    { id: '7', label: '週日' },
  ]

  const byId = indexBy(prop('id'), data)

  return {
    data,
    byId,
    statusEnum,
  }
}

export const useCouponTypeEnum = () => {
  const statusEnum = {
    DIFF: 0,
    SAME: 1,
  }

  const data = [
    {
      id: 0,
      label: '不同序號',
    },
    {
      id: 1,
      label: '相同序號',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    statusEnum,
  }
}

export const useAppBannerTypeEnum = () => {
  const typeEnum = {
    EXTERNAL_LINK: 0,
    REWARD_MISSION: 1,
  }
  const data = [
    {
      id: typeEnum.EXTERNAL_LINK,
      label: '外部連結',
    },
    {
      id: typeEnum.REWARD_MISSION,
      label: '獎勵任務',
    },
  ]

  const byId = indexBy(x => x.id, data)

  return {
    data,
    byId,
    typeEnum,
  }
}
